import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from 'src/app/service/api.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-empresas-auditar',
  templateUrl: './empresas-auditar.component.html',
  styleUrls: ['./empresas-auditar.component.css']
})
export class EmpresasAuditarComponent implements OnInit {
  var_l: any;
  var_q: any;
  var_r: any;
  var_v: any;
  var_a: any;
  var_vr: any;
  var_owlCar: any;
  justificarResposta: boolean = false;
  justificativa: string = '';

  jsonArrayDescricao: any;
  descricao: string = '';
  jsonArray: any;
  jsonArrayValor: any;
  btnvoltar = false;
  btnfinal = false;
  contador = 0;
  segmentoid: string;
  observacao: boolean;
  alertaquestao: boolean;
  valorquestionario: string = "0";
  formAvaliar: FormGroup;
  lojistaid:string;
  modalRef: BsModalRef;
  modalProtocoloRef: BsModalRef;
  imgprot: string = '';
  tituloprot: string = '';
  descricaoprot: string = '';
  jsonArrayAvaliacao:any;
  valornotassalvas:number=0;
  questionariovalor:number=0;

  config = {
    keyboard: false,
    backdrop: false,
    ignoreBackdropClick: true
  };

  customOptions: any = {
    loop: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 1
      },
      940: {
        items: 1
      }
    },
    nav: false
  }

  constructor(private modalService: BsModalService, private apiService: ApiService, public formBuilder: FormBuilder,
              private spinner: NgxSpinnerService, private router: Router, private toastr: ToastrService) { }

  ngOnInit() {
    this.formAvaliar = this.formBuilder.group({
      idface: [''],
      lojistaid: [''],
      dadosavaliar: [''],
      valorquestionario: ['']
    });

    this.spinner.show();
    this.apiService.getListagem('lojistaspagos')
      .subscribe(
        (data) => { //start of (1)

          this.jsonArrayDescricao = data;

          this.spinner.hide();

          //this.getGeolocation();

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  carregarAvaliacao(e) {
    this.router.navigate(['/classificacao', e.lojistaid]);
  }

  autoAvaliacao(template, item) {
    this.spinner.show();
    this.jsonArray = [];
    this.jsonArrayValor = [];

    this.btnvoltar = false;
    this.btnfinal = false;
    this.contador = 0;
    this.lojistaid = item.lojistaid;

    this.modalRef = this.modalService.show(template, this.config);

    this.apiService.getListagemId('questoesavaliar', item.lojistaid)
      .subscribe(
        (data) => { //start of (1)

          this.jsonArray = data;

          if (this.jsonArray.length > 0) {
            this.segmentoid = this.jsonArray[0].segmentoid;
            this.observacao = true;
            this.alertaquestao = false;
            this.carregarTotalNota();
          } else {
            this.spinner.hide();
            this.observacao = false;
            this.alertaquestao = true;
          }

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  carregarTotalNota() {
    this.apiService.getListagemId('valorquestionario', this.segmentoid)
      .subscribe(
        (data) => { //start of (1)

          this.jsonArrayValor = data;

          this.valorquestionario = this.jsonArrayValor[0].valor;

          this.formAvaliar.setValue({
            idface: [this.lojistaid],
            lojistaid: [this.lojistaid],
            dadosavaliar: [''],
            valorquestionario: [this.valorquestionario]
          });

          console.log("VALOR QUESTIONARIO: " + this.valorquestionario);

          this.spinner.hide();

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  protocoloAvaliar(template: TemplateRef<any>, item) {
    this.modalProtocoloRef = this.modalService.show(template, this.config);

    this.imgprot = item.imagem;
    this.tituloprot = item.questao;
    this.descricaoprot = item.descricaoimagem;
  }

  swipeNext(l, q, r, v, a, vr, owlCar) {
    this.var_l = l;
    this.var_q = q;
    this.var_r = r;
    this.var_v = v;
    this.var_a = a;
    this.var_vr = vr;
    this.var_owlCar = owlCar;

    this.justificarResposta = true;
  }

  proximaQuestao(owlCar) {
    // + ' AND respostaid =' + r
    if (this.justificativa.length < 20) {
      this.toastr.warning('Justifique sua resposta! (minímo de 20 caracteres)', 'Atenção!');
    } else {
      this.justificativa = '';
      this.justificarResposta = false;
      var valor = "0";
      var nota = "0";

      if (this.var_a === 'N') {
        valor = this.var_vr;
        nota = '0';
      } else {
        valor = '0';
        nota = this.var_v;
      }

      if (this.contador === this.jsonArray.length) {
        this.contador = this.jsonArray.length;
      } else {
        this.contador++;
      }

      if (this.contador === 0) {
        this.btnvoltar = false;
      } else {
        this.btnvoltar = true;
        if (this.contador === this.jsonArray.length) {
          this.btnfinal = true;
        } else {
          this.btnfinal = false;
        }
      }

      owlCar.next();

      this.apiService.salvarRespostas('salvarresposta', this.var_l, this.var_q, this.var_r, this.var_v, this.var_a, valor, this.justificativa)
        .subscribe(
          (data) => { //start of (1)

          }, //end of (1)
          (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
          () => console.log('all data gets') //(3) second argument
        );
    }

  }

  swipePrev(lojistaid, questionarioid, owlCar) {
    setTimeout(() => {
      this.contador--;
      this.justificativa = '';
      this.justificarResposta = false;

      if (this.contador === 0) {
        this.btnvoltar = false;
      } else {
        this.btnvoltar = true;
        if (this.contador === this.jsonArray.length) {
          this.btnfinal = true;
        } else {
          this.btnfinal = false;
        }
      }

      owlCar.prev();

      this.apiService.cancelarRespostas('cancelarresposta', lojistaid, questionarioid)
        .subscribe(
          (data) => { //start of (1)

          }, //end of (1)
          (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
          () => console.log('all data gets') //(3) second argument
        );

    }, 250);
  }

  finalizarAvaliacao() {
    this.spinner.show();
    this.apiService.getListagemId('carregarnotasavaliar', this.lojistaid)
      .subscribe(
        (data) => { //start of (1)

          this.jsonArrayAvaliacao = data;

          var totaldesc = 0;

          for (var i = 0; i < this.jsonArrayAvaliacao.length; i++) {
            totaldesc += parseFloat(this.jsonArrayAvaliacao[i].valorabater);
            this.valornotassalvas += parseFloat(this.jsonArrayAvaliacao[i].notavalor);
          }

          this.questionariovalor = parseFloat(this.valorquestionario) - totaldesc;

          setTimeout(() => {
            this.salvarAvaliacaoCalculo();
          }, 500);

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  salvarAvaliacaoCalculo() {
    //console.log("JSON: " + JSON.stringify(this.formAvaliar.get('dadosavaliar').value));

    var notafinal = (this.valornotassalvas / this.questionariovalor) * 100;

    //console.log(notafinal);

    this.apiService.saveCadastroId('salvaravaliacaocalculo', this.lojistaid, notafinal.toFixed(0), this.lojistaid)
      .subscribe(
        (data) => { //start of (1)

          this.modalRef.hide();
          this.spinner.hide();

          this.abrirAvaliacao();

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  abrirAvaliacao() {
    this.modalRef.hide();
    this.router.navigate(['/avaliacao-auditor', this.lojistaid], { replaceUrl: true });
  }
}
